import { useSelector } from 'react-redux';
import { caseLimitReachedHtml } from '../utils/constant';
import { confirm } from '../utils/swal';

const LIMIT_REACHED_TITLE = 'Subscription Limit Reached';

const useDemandCreditCheck = () => {
  const { subscription } = useSelector((state) => state.users || {});
  const { rollOverCredits = 0, remainingDemand = 0, chargeAdditionalPlaintiffs } = subscription || {};

  const availableCredits = remainingDemand + rollOverCredits;

  // mirrors the billing rule in the PFQ: plaintiffs past the first only cost a credit when the firm is charged for them
  const getRequiredCredits = ({ plaintiffCount = 1 }) =>
    chargeAdditionalPlaintiffs === false ? 1 : Math.max(1, plaintiffCount);

  // advisory only, confirming lets the demand through and is billed at the per-demand rate
  const confirmDemandCredit = async ({ plaintiffCount } = {}) => {
    if (availableCredits >= getRequiredCredits({ plaintiffCount })) return true;

    const { isConfirmed } = await confirm({
      title: LIMIT_REACHED_TITLE,
      html: caseLimitReachedHtml
    });

    return isConfirmed;
  };

  return { confirmDemandCredit };
};

export default useDemandCreditCheck;
